import { FiTrash2, FiX, FiLoader } from "react-icons/fi";

export default function ImagePreview({
  open,
  images = [],
  photoIndex = 0,
  setPhotoIndex,
  onClose,
  onDelete,
  loadingDelete = false,
  baseUrl = "",
}) {
  if (!open) return null;

  const currentImage = images[photoIndex];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md">
      {/* Action Buttons */}
      <div className="absolute top-6 right-6 flex items-center gap-3">
        <button
          type="button"
          onClick={() => onDelete?.(currentImage?.id)}
          className="p-3 bg-red-500/50 hover:bg-red-500/90 rounded-full text-white transition-all"
        >
          {loadingDelete ? (
            <FiLoader className="animate-spin" />
          ) : (
            <FiTrash2 size={24} />
          )}
        </button>

        <button
          onClick={onClose}
          className="p-3 bg-white/10 hover:bg-white/20 rounded-full text-white transition-all"
        >
          <FiX size={24} />
        </button>
      </div>

      {/* Image Content */}
      <div className="max-w-4xl max-h-[80vh] px-4 flex flex-col items-center">
        {currentImage && (
          <img
            src={`${baseUrl}/storage/${currentImage.image}`}
            alt="Preview"
            className="w-full h-full object-contain rounded-lg shadow-2xl"
          />
        )}

        {/* Navigation Dots */}
        {images.length > 1 && (
          <div className="flex gap-4 mt-6">
            {images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setPhotoIndex(idx)}
                className={`w-3 h-3 rounded-full transition-all ${
                  idx === photoIndex
                    ? "bg-indigo-500 scale-125"
                    : "bg-gray-500"
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
